import React, { useState } from 'react';
import { Form, Modal } from '@douyinfe/semi-ui';
import RichEditor from '../../../RichEditor';
import { ModuleStyleForm } from '../../components/ModuleBase/ModuleBase';
import { config } from './config';

export const RichTextStyleForm = ({ data = {}, onChange }) => {
    const [visible, setVisible] = useState(false);
    const defaultData = {
        ...config.defaultProps
    };

    const handleContentChange = (content) => {
        const newData = {
            ...defaultData,
            ...data,
            content
        };
        onChange?.(newData);
    };

    const handleStyleChange = (style) => {
        const newData = {
            ...defaultData,
            ...data,
            ['style']: { ...data.style, ...style }
        };
        onChange?.(newData);
    };

    return (
        <Form labelPosition="left" labelAlign="right">
            <div
                onClick={() => setVisible(true)}
                style={{
                    cursor: 'pointer',
                    padding: '8px',
                    border: '1px dashed var(--semi-color-border)',
                    borderRadius: '4px',
                    minHeight: '100px'
                }}
                dangerouslySetInnerHTML={{ __html: data?.content || defaultData.content }}
            />
            <Modal
                title="编辑富文本内容"
                visible={visible}
                onCancel={() => setVisible(false)}
                footer={null}
                width={800}
                height={600}
                centered
            >
                <Form.Slot label="内容">
                    <RichEditor
                        value={data?.content || defaultData.content}
                        onChange={handleContentChange}
                    />
                </Form.Slot>
            </Modal>
            <ModuleStyleForm
                style={data?.style || defaultData.style}
                onChange={handleStyleChange}
            />
        </Form>
    );
};

export default RichTextStyleForm;